export default {
    // Header Section
    "discover_your": "जानें अपना",
    "health_report": "स्वास्थ्य रिपोर्ट",
    "astrological_health_insights": "ज्योतिषीय स्वास्थ्य अंतर्दृष्टि",
    "health_report_description": "वैदिक ज्योतिष के आधार पर व्यापक स्वास्थ्य विश्लेषण प्राप्त करें। अपने स्वास्थ्य की कमजोरियां, रोग प्रवृत्तियां, रोकथाम के उपाय और व्यक्तिगत स्वास्थ्य अनुशंसाएं जानें ताकि आपका स्वास्थ्य सर्वोत्तम बना रहे।",

    // Service Information
    "enter_details_for_health_analysis": "स्वास्थ्य विश्लेषण के लिए अपनी जानकारी दर्ज करें",
    "complete_health_analysis": "पूर्ण स्वास्थ्य विश्लेषण",
    "service_price": "सेवा शुल्क",
    "comprehensive_health_analysis_note": "आपके स्वास्थ्य पैटर्न का गहन विश्लेषण और व्यक्तिगत स्वास्थ्य मार्गदर्शन",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_health_influence": "आपके नाम की ऊर्जा आपके स्वास्थ्य और उपचार पैटर्न को प्रभावित करती है",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फ़ोन नंबर",
    "enter_phone_number": "अपना फ़ोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "महिला",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_health_insights": "स्वास्थ्य से संबंधित ग्रह स्थिति जानने के लिए आवश्यक",
    "time_of_birth": "जन्म समय",
    "exact_time_critical_for_health": "स्वास्थ्य घर की सही गणना के लिए सटीक समय आवश्यक है",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "location_essential_for_health": "स्थान ग्रहों की स्थिति को प्रभावित करता है जो स्वास्थ्य पर असर डालते हैं",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेज़ी",
    "hindi": "हिंदी",
    "telugu": "तेलुगु",
    "kannada": "कन्नड़",
    "language_note": "आपका स्वास्थ्य विश्लेषण चयनित भाषा में दिया जाएगा",

    // Core Health Features
    "health_vulnerabilities_analysis": "स्वास्थ्य कमजोरियों का विश्लेषण",
    "disease_predisposition_insights": "रोग प्रवृत्ति की जानकारी",
    "preventive_health_measures": "स्वास्थ्य रोकथाम के उपाय",
    "dietary_lifestyle_recommendations": "आहार और जीवनशैली की सिफारिशें",
    "healing_gemstones_remedies": "उपचारात्मक रत्न और उपाय",
    "pdf_download": "विस्तृत PDF रिपोर्ट",

    "what_you_get": "आपको क्या मिलेगा",
    "comprehensive_health_chart": "विस्तृत स्वास्थ्य चार्ट",
    "body_system_analysis": "शरीर प्रणाली का विश्लेषण",
    "preventive_care_guidance": "रोकथाम देखभाल मार्गदर्शन",
    "wellness_enhancement_tips": "स्वास्थ्य सुधार सुझाव",

    // Actions & Buttons
    "pay_and_generate_analysis": "मेरा स्वास्थ्य विश्लेषण प्राप्त करें",
    "processing_payment": "भुगतान प्रक्रिया में...",
    "processing_request": "विश्लेषण तैयार हो रहा है...",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "health_analysis_processing": "हमारे विशेषज्ञ मेडिकल ज्योतिषी आपका स्वास्थ्य विश्लेषण तैयार कर रहे हैं। आपको अपने स्वास्थ्य पैटर्न और व्यक्तिगत स्वास्थ्य मार्गदर्शन की विस्तृत जानकारी प्राप्त होगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_12_hours_delivery_note": "आपकी विस्तृत स्वास्थ्य रिपोर्ट 12 घंटों के भीतर तैयार हो जाएगी",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूर्ण विश्लेषण भेजा जाएगा",

    // What You'll Receive
    "what_youll_receive": "आपको क्या मिलेगा",
    "detailed_health_report": "विस्तृत स्वास्थ्य रिपोर्ट (PDF)",
    "body_system_vulnerability_analysis": "शरीर प्रणाली की कमजोरियों का विश्लेषण",
    "preventive_healthcare_plan": "रोकथाम स्वास्थ्य योजना",
    "dietary_wellness_guidelines": "आहार और स्वास्थ्य दिशानिर्देश",
    "healing_remedies_recommendations": "उपचार और अनुशंसाएं",

    // Visual Content
    "sample_health_analysis": "नमूना स्वास्थ्य विश्लेषण",
    "health_strength_indicator": "स्वास्थ्य शक्ति सूचक",
    "sample_health_reading": "मजबूत जीवन शक्ति, हृदय स्वास्थ्य पर ध्यान",
    "sample_health_preview": "आपके व्यक्तिगत स्वास्थ्य विश्लेषण का पूर्वावलोकन",
    "health_categories": "स्वास्थ्य श्रेणियां",

    // Health System Types
    "cardiovascular": "हृदय संबंधी",
    "neurological": "तंत्रिका संबंधी",
    "respiratory": "श्वसन संबंधी",
    "digestive": "पाचन संबंधी",
    "skeletal": "अस्थि संबंधी",
    "immune_system": "प्रतिरक्षा प्रणाली",

    // Status & Processing
    "your_health_analysis_status": "आपके स्वास्थ्य विश्लेषण की स्थिति",
    "processing_your_analysis": "आपके स्वास्थ्य पैटर्न का विश्लेषण हो रहा है",
    "analysis_processing_message": "हमारे मेडिकल ज्योतिष विशेषज्ञ आपके ग्रहों की स्थिति का अध्ययन कर रहे हैं ताकि आपके स्वास्थ्य की कमजोरियां और स्वास्थ्य सुझाव निर्धारित कर सकें।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति पर",
    "pending": "लंबित",
    "email_notification_sent": "पुष्टि ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्रिय",
    "delivery_within_12_hours": "रिपोर्ट 12 घंटों में तैयार होगी",

    // Support & Contact
    "contact_support": "स्वास्थ्य सहायता से संपर्क करें",
    "need_help": "क्या आपको मदद चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक जन्म विवरण भरें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण असफल रहा। कृपया सहायता टीम से संपर्क करें।",

    // Health-Specific Elements
    "sixth_house": "छठा भाव (स्वास्थ्य भाव)",
    "eighth_house": "आठवां भाव (दीर्घकालिक स्वास्थ्य)",
    "twelfth_house": "बारहवां भाव (अस्पताल में भर्ती)",
    "ascendant_health": "लग्न और समग्र जीवन शक्ति",
    "moon_health": "चंद्रमा और मानसिक स्वास्थ्य",
    "mars_energy": "मंगल और शारीरिक ऊर्जा",

    // Body Systems Analysis
    "circulatory_system": "संचार प्रणाली",
    "nervous_system": "तंत्रिका तंत्र",
    "respiratory_system": "श्वसन तंत्र",
    "digestive_system": "पाचन तंत्र",
    "musculoskeletal_system": "मांसपेशी और अस्थि तंत्र",
    "endocrine_system": "अंतःस्रावी तंत्र",
    "reproductive_system": "प्रजनन तंत्र",
    "excretory_system": "उत्सर्जन तंत्र",

    // Health Vulnerabilities
    "genetic_predispositions": "आनुवंशिक प्रवृत्तियां",
    "chronic_condition_risks": "दीर्घकालिक रोग जोखिम",
    "acute_illness_patterns": "अल्पकालिक रोग पैटर्न",
    "mental_health_factors": "मानसिक स्वास्थ्य कारक",
    "stress_vulnerability": "तनाव संवेदनशीलता",
    "injury_prone_areas": "चोट लगने वाले क्षेत्र",

    // Preventive Measures
    "early_warning_signs": "प्रारंभिक चेतावनी संकेत",
    "regular_checkup_schedule": "नियमित जांच अनुसूची",
    "screening_recommendations": "स्वास्थ्य जांच अनुशंसाएं",
    "vaccination_guidance": "टीकाकरण मार्गदर्शन",
    "lifestyle_modifications": "जीवनशैली में बदलाव",
    "exercise_prescriptions": "व्यायाम निर्देश",

    // Dietary Recommendations
    "constitutional_diet": "संविधान आधारित आहार योजना",
    "foods_to_include": "शामिल करने वाले खाद्य पदार्थ",
    "foods_to_avoid": "परहेज करने वाले खाद्य पदार्थ",
    "meal_timing": "भोजन का सही समय",
    "seasonal_adjustments": "मौसमी आहार समायोजन",
    "supplementation_needs": "पूरक की आवश्यकता",

    // Lifestyle Guidance
    "sleep_patterns": "सर्वोत्तम नींद पैटर्न",
    "exercise_routine": "अनुशंसित व्यायाम दिनचर्या",
    "stress_management": "तनाव प्रबंधन तकनीक",
    "work_life_balance": "काम और जीवन में संतुलन",
    "environmental_factors": "पर्यावरणीय स्वास्थ्य कारक",
    "social_health": "सामाजिक और भावनात्मक स्वास्थ्य",

    // Healing & Remedies
    "ayurvedic_remedies": "आयुर्वेदिक उपचार",
    "herbal_recommendations": "हर्बल सिफारिशें",
    "gemstone_therapy": "रत्न चिकित्सा",
    "color_therapy": "रंग चिकित्सा",
    "sound_healing": "ध्वनि चिकित्सा",
    "yoga_practices": "चिकित्सीय योग अभ्यास",
    "meditation_techniques": "चिकित्सीय ध्यान तकनीक",
    "breathing_exercises": "प्राणायाम और श्वसन अभ्यास",

    // Mental Health
    "psychological_patterns": "मनोवैज्ञानिक पैटर्न",
    "emotional_balance": "भावनात्मक संतुलन",
    "mental_clarity": "मानसिक स्पष्टता बढ़ाना",
    "memory_concentration": "स्मृति और एकाग्रता",
    "anxiety_management": "चिंता प्रबंधन",
    "depression_prevention": "अवसाद रोकथाम",

    // Timing & Cycles
    "health_cycles": "व्यक्तिगत स्वास्थ्य चक्र",
    "vulnerable_periods": "संवेदनशील स्वास्थ्य अवधि",
    "recovery_periods": "प्राकृतिक स्वस्थ होने की अवधि",
    "optimal_treatment_timing": "उपचार का सही समय",
    "surgery_timing": "सर्जरी का समय",
    "detox_periods": "डिटॉक्स अवधि",

    // Age-Related Health
    "childhood_health": "बचपन का स्वास्थ्य पैटर्न",
    "adolescent_health": "किशोरावस्था स्वास्थ्य समस्याएं",
    "adult_health": "वयस्क स्वास्थ्य देखभाल",
    "middle_age_concerns": "मध्य आयु स्वास्थ्य चिंताएं",
    "senior_health": "वरिष्ठ नागरिक स्वास्थ्य मार्गदर्शन",
    "longevity_factors": "दीर्घायु कारक",

    // Women's Health
    "menstrual_health": "मासिक धर्म स्वास्थ्य",
    "fertility_factors": "प्रजनन क्षमता कारक",
    "pregnancy_guidance": "गर्भावस्था स्वास्थ्य मार्गदर्शन",
    "menopause_management": "रजोनिवृत्ति प्रबंधन",
    "hormonal_balance": "हार्मोनल संतुलन",

    // Men's Health
    "vitality_enhancement": "जीवन शक्ति वृद्धि",
    "prostate_health": "प्रोस्टेट स्वास्थ्य",
    "testosterone_balance": "टेस्टोस्टेरोन संतुलन",
    "cardiovascular_focus": "हृदय स्वास्थ्य पर ध्यान",
    "stress_related_issues": "तनाव संबंधित समस्याएं",

    // Specialty Areas
    "skin_health": "त्वचा और सौंदर्य स्वास्थ्य",
    "eye_health": "आंखों का स्वास्थ्य",
    "dental_health": "दंत स्वास्थ्य",
    "hair_health": "बालों का स्वास्थ्य",
    "joint_health": "जोड़ों का स्वास्थ्य",
    "metabolic_health": "मेटाबॉलिक स्वास्थ्य",

    // Emergency Preparedness
    "health_emergencies": "स्वास्थ्य आपात स्थिति तैयारी",
    "first_aid_guidance": "प्राथमिक चिकित्सा मार्गदर्शन",
    "emergency_contacts": "आपातकालीन स्वास्थ्य संपर्क",
    "medication_management": "दवा प्रबंधन",
    "allergy_alerts": "एलर्जी अलर्ट",

    // Holistic Wellness
    "mind_body_connection": "मन-शरीर संबंध",
    "spiritual_healing": "आध्यात्मिक चिकित्सा",
    "energy_healing": "ऊर्जा चिकित्सा",
    "chakra_balancing": "चक्र संतुलन",
    "aura_cleansing": "आभा शुद्धिकरण",
    "holistic_integration": "समग्र स्वास्थ्य समेकन"
};
